module.exports = __webpack_public_path__ + "static/media/video.22f5fbdf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video.svg
// module id = 1446
// module chunks = 0